import type { ReactNode } from 'react';
import { CalendarCheck, KanbanSquare, ShieldCheck, Sparkles } from 'lucide-react';

/** Split-screen frame for sign-in pages: brand panel left (desktop only), form right. */
export function AuthShell({ children }: { children: ReactNode }) {
  return (
    <div className="grid min-h-dvh bg-background lg:grid-cols-2">
      <div className="relative hidden flex-col justify-between overflow-hidden bg-gradient-to-br from-indigo-700 via-indigo-600 to-slate-900 p-10 text-white lg:flex">
        <div className="flex items-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/15 ring-1 ring-white/25"><Sparkles className="h-5 w-5" /></div>
          <span className="text-lg font-semibold tracking-tight">Business Sense</span>
        </div>
        <div className="max-w-md">
          <h2 className="text-3xl font-semibold leading-tight tracking-tight">Know who to contact today, and what to say.</h2>
          <ul className="mt-8 space-y-4 text-[15px] text-white/85">
            <li className="flex gap-3"><CalendarCheck className="h-5 w-5 shrink-0" /> A ranked list every morning, with the reason for each person.</li>
            <li className="flex gap-3"><KanbanSquare className="h-5 w-5 shrink-0" /> Pharma, Education and SEO in one place.</li>
            <li className="flex gap-3"><ShieldCheck className="h-5 w-5 shrink-0" /> Nothing is sent to clients without you. You copy and send.</li>
          </ul>
        </div>
        <p className="text-xs text-white/60">ImpactPlus · internal use only</p>
        <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-white/10 blur-3xl" aria-hidden />
      </div>
      <div className="flex items-center justify-center px-4 py-12 sm:px-8">
        <div className="w-full max-w-sm">
          <div className="mb-8 flex items-center gap-2.5 lg:hidden">
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary text-primary-foreground"><Sparkles className="h-5 w-5" /></div>
            <span className="text-lg font-semibold">Business Sense</span>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
